const doc = [({"en":({"js":({"admin":({"logs":({"table":({"name":"Name", "trackable_type":"Trackable type", "trackable_id":"Trackable ID", "key":"Key", "system":"System"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;